import React from "react";
import EarlyAccessButton from "../EarlyAccessButton";
import styles from "./styles.module.scss";

interface ComputerUseSectionProps {
  onDownloadClick: () => void;
}

/**
 * ComputerUseSection 组件
 * 展示桌面文件处理功能
 */
const ComputerUseSection = ({ onDownloadClick }: ComputerUseSectionProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        {/* 左侧部分 - 文本内容 */}
        <div className={styles.textContentSection}>
          <div className={styles.textContentInner}>
            <h2 className={styles.mainTitle}>
              <div className={styles.titleLine}>
                Fellou is for <span className={styles.highlight}>Control.</span>
              </div>
            </h2>

            <div className={styles.computerComparisonText}>
              <div className={styles.computerComparisonLine}>Never work in a black box. </div>
              <div className={styles.computerComparisonLine}>You're always in charge.</div>
            </div>

            <EarlyAccessButton onClick={onDownloadClick} />
          </div>
        </div>

        {/* 右侧部分 - 视频展示（替代动画演示） */}
        <div className={styles.videoSection}>
          <div className={styles.videoContainer}>
            <video autoPlay muted loop playsInline className={styles.videoElement}>
              <source
                src="https://fellou.s3.us-west-1.amazonaws.com/videos/website-main-page/Website+main+page+animation/Controllable+workflow.webm"
                type="video/webm"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComputerUseSection;
